import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import VideoViewContent from 'component/video/VideoViewContent'
import VideoRemoveContent from 'component/video/VideoRemoveContent'
import VideoUpdateContent from 'component/video/VideoUpdateContent'

const REMOVE = 'VIDEOS_REMOVE'
const UPDATE = 'VIDEOS_UPDATE'
const VIEW = 'VIDEOS_VIEW'

class VideosModal extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    openEditModal: PropTypes.func,
    initialValues: PropTypes.object,
    user: PropTypes.object,
  }

  constructor(props) {
    super(props)

    if (window.innerWidth < 1580) {
      this.state = {
        size: 'sm',
      }
    } else {
      this.state = {
        size: 'xs',
      }
    }

    this.renderContent = this.renderContent.bind(this)
  }

  renderContent(props) {
    switch (props.modalType) {
      case VIEW:
        return <VideoViewContent {...props} />

      case REMOVE:
        return <VideoRemoveContent {...props} />

      case UPDATE:
        const newProps = {
          ...props,
          initialValues: {
            ...props.initialValues,
            nmVideo: props.initialValues.videoTitle,
            dsVideo: props.initialValues.videoDescription,
            dtStart: props.initialValues.startDate,
            dtEnd: props.initialValues.endDate,
          },
        }

        return <VideoUpdateContent {...newProps} />
      default:
        return <Fragment />
    }
  }

  render() {
    const { size } = this.state

    return (
      <Modal closeModal={this.props.closeModal} size={size}>
        {this.renderContent(this.props)}
      </Modal>
    )
  }
}

export default VideosModal
